var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    stroke: "#500D76",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bsh8m44vra)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.08 20.91V21a2 2 0 0 0 4 0v-.17a1.65 1.65 0 0 1 1-1.51 1.65 1.65 0 0 1 1.82.33l.06.06a2 2 0 0 0 3.264-.65 2 2 0 0 0-.434-2.18l-.06-.06A1.65 1.65 0 0 1 19.4 15a1.65 1.65 0 0 1 1.51-1H21a2 2 0 0 0 0-4h-.17a1.65 1.65 0 0 1-1.51-1v-.08a1.65 1.65 0 0 1 .33-1.82l.06-.06a2 2 0 1 0-2.83-2.83l-.06.06A1.65 1.65 0 0 1 15 4.6a1.65 1.65 0 0 1-1-1.51V3a2 2 0 1 0-4 0v.17a1.65 1.65 0 0 1-1 1.51h-.08a1.65 1.65 0 0 1-1.82-.33l-.06-.06a2 2 0 1 0-2.83 2.83l.06.06A1.65 1.65 0 0 1 4.6 9a1.65 1.65 0 0 1-1.51 1.08H3a2 2 0 1 0 0 4h.17",
    stroke: "{stroke}",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.5 20.5 6-5",
    stroke: "{stroke}",
    strokeWidth: 2.004,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b5lrcs0f1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.45 12.8c.635 0 1.164.522 1.013 1.14a4.802 4.802 0 0 1-6.067 3.45 4.8 4.8 0 0 1 1.539-9.388c.635.018.998.666.83 1.278-.168.613-.82.945-1.443 1.066a2.51 2.51 0 0 0-1.594 1.056 2.5 2.5 0 1 0 4.312 2.508c.282-.57.775-1.11 1.41-1.11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.45 12.8c.635 0 1.164.522 1.013 1.14a4.802 4.802 0 0 1-6.067 3.45 4.8 4.8 0 0 1 1.539-9.388c.635.018.998.666.83 1.278-.168.613-.82.945-1.443 1.066a2.51 2.51 0 0 0-1.594 1.056 2.5 2.5 0 1 0 4.312 2.508c.282-.57.775-1.11 1.41-1.11z",
    stroke: "{stroke}",
    strokeWidth: 4.8,
    mask: "url(#b5lrcs0f1b)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bsh8m44vra"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigure);
export default __webpack_public_path__ + "static/media/configure.6d8b966fcae88a576af5117b46eb4154.svg";
export { ForwardRef as ReactComponent };